import { Grid } from '@mui/system';
import ScalarDatasheet from 'components/ScalarDatasheet';
import { TransactionsTableCompsProps } from './GpcTableComps.props';

const TransactionsTableComps = ({ GPCDataGrid, onCellsChanged }: TransactionsTableCompsProps) => (
  <Grid size={{ xs: 12 }}>
    <ScalarDatasheet
      className="comp-datasheet transactions-table-comps"
      data={GPCDataGrid}
      onCellsChanged={onCellsChanged}
    />
  </Grid>
);

export default TransactionsTableComps;
